export function checkMinViewport(width) {
  return window.matchMedia(`(min-width: ${width}px)`).matches;
}

export function checkMaxViewport(width) {
  return window.matchMedia(`(max-width: ${width}px)`).matches;
}

/**
 * Check if this device is mobile or not
 * @returns {Boolean}
 */
export function isMobile() {
  let isMobileDevice = false;

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    isMobileDevice = true;
  }

  return isMobileDevice;
}

/**
 * get youtube id
 */
export function getYoutubeID(_url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = _url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}
